import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { devices_settings } from 'src/stores/device-runtime/status';
import { capFirstChar } from 'src/helpers/utilities';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';
import type { LabelProps } from '@Shelly/shelly-design-system/index';

export const buildPresenceLabels = (
	deviceID: Device['id'],
	method: string,
	job: ActionJob,
	labelList: LabelProps[],
): LabelProps[] => {
	const $format = get(format);
	if (/^(presencezone.setconfig)$/.test(method) && job.params?.config) {
		const deviceSettings = devices_settings.getByRealId(deviceID);
		const presenceZone = deviceSettings?.[`presencezone:${job.params?.id}`];
		if (!presenceZone) return labelList;
		const config = job.params.config;
		labelList.push({
			value: presenceZone.name,
		});
		if (config.enable != null) {
			const enable = config.enable === true;
			labelList.push({
				value: capFirstChar(
					enable
						? $format('enable', { default: 'enable' })
						: $format('disable', { default: 'disable' }),
				),
				icon: `fas fa-toggle-${enable === true ? 'on' : 'off'}`,
				iconColor: enable === true ? '--color-success' : '--color-danger',
			});
		}
	}
	return labelList;
};

export const getPresenceZoneOptions = () => {
	const $format = get(format);
	return [
		{
			title: $format('label_occupied', {
				default: 'Occupied',
			}),
			value: 'true',
		},
		{
			title: $format('label_not_occupied', {
				default: 'Not occupied',
			}),
			value: 'false',
		},
	];
};
